import { LoginProps } from "../../user/types/user";

export function mustChangePassword(user?: LoginProps | null): boolean {
	if (!user) return false;
	if (user.profile === "4") return false;
	return user.first_login !== "0";
}
